import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import PageFrame from '../../components/commons/pageFrame';
import { NavigationMenu } from '../../components/navigationMenu';
import { useOrientation } from '../../hooks/useOrientation';
import { PreHome } from '../preHome';
import './index.scss';

const Home = () => {
  const { locationKey } = useSelector((state) => state.location);
  const [isPreHomeVisited, setPreHomeVisited] = useState(null);
  const { orientation } = useOrientation();
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  });

  useEffect(() => {
    setPreHomeVisited(JSON.parse(sessionStorage.getItem('welcome')) || false);
  }, [orientation, location]);

  return (
    <>
      {isPreHomeVisited ? (
        <PageFrame>
          <div
            className={`page-navigation_wrapper ${orientation.screenOrientation}`}
          >
            <NavigationMenu initialState={locationKey} />
          </div>
        </PageFrame>
      ) : (
        <PreHome setPreHomeVisited={setPreHomeVisited} />
      )}
    </>
  );
};

export default Home;
